<p-dialog [closable]="false" *ngIf="loader._isLoading" [visible]="loader._isLoading" [modal]="true">
  <div style="width: 100%; overflow: hidden; text-align: center">
    <p-progressSpinner></p-progressSpinner>
  </div>
</p-dialog>

<div class="layout-wrapper" [ngClass]="{'layout-compact':layoutCompact}" (click)="onLayoutClick()">

  <div #layoutContainer class="layout-container"
       [ngClass]="{'menu-layout-static': false,
            'menu-layout-overlay': true,
            'layout-menu-overlay-active': overlayMenuActive,
            'menu-layout-horizontal': false,
            'menu-layout-slim': false,
            'layout-menu-static-inactive': staticMenuDesktopInactive,
            'layout-menu-static-active': staticMenuMobileActive}">

    <app-topbar></app-topbar>

    <div class="layout-menu" [ngClass]="{'layout-menu-dark':darkMenu}" (click)="onMenuClick($event)">
      <p-scrollPanel #scrollPanel [style]="{height: '100%'}">-->
        <app-inline-profile *ngIf="profileMode=='inline'&&!isHorizontal()" [hidden]="!layout.profileView"></app-inline-profile>
        <app-menu [reset]="resetMenu"></app-menu>
      </p-scrollPanel>
    </div>

    <div class="layout-main">
      <!--<app-breadcrumb *ngIf="layout.breadcrumb"></app-breadcrumb>-->

      <div class="layout-content">
        <router-outlet></router-outlet>

        <!--<app-footer *ngIf="layout.footerView"></app-footer>-->
      </div>
    </div>

    <app-rightpanel *ngIf="layout.rightPanel"></app-rightpanel>

    <div class="layout-mask"></div>

    <app-valdemort-default></app-valdemort-default>
  </div>

  <app-confirm-dialog></app-confirm-dialog>
  <p-blockUI [blocked]="this.ui.blocked$ | async"></p-blockUI>

</div>
